import gql from 'graphql-tag';
import { TransactionFragment } from '../fragments/transaction.fragment';

export const PROCESS_ONE_CREDITOUT = gql`
    mutation(
        $id: String!
    ) {
        processOneCreditOut (
            id: $id
        ) {
            ...TransactionInfo       
        }
    }
    ${TransactionFragment}
`;